module.exports = __webpack_public_path__ + "public-ui/fonts/latin.9a01b691.woff2";